<app-retailer-list [url]="API.LIST_RETAILER_REJECT"
                   [tableColumns]="tableColumns"
                   (totalCount)="handleCount($event)"
                   [dataList]="dataList"
></app-retailer-list>
